import { api } from './api.js';
import { session } from './session.js';

/**
 * Perfil do usuário logado (GET /v1/me), com cache em memória.
 * @typedef {{ profileComplete: boolean, user: null | {
 *   id: string, name: string, email: string, cpf: string, phone: string | null,
 *   role: 'USER' | 'MECHANIC', status: string, createdAt: string },
 *   workshop?: null | { id: string, name: string, status: string, role: 'MANAGER' | 'MECHANIC' } }} Me
 */

/** @type {Me | null} */
let cache = null;

session.events.addEventListener('change', () => {
  if (!session.isLoggedIn) cache = null;
});

export const me = {
  /** @returns {Promise<Me>} */
  async load({ force = false } = {}) {
    if (cache && !force) return cache;
    cache = await api('GET', '/v1/me');
    return cache;
  },

  /** @param {Me} value */
  set(value) {
    cache = value;
  },

  get current() {
    return cache;
  },

  completeProfile(data) {
    return api('POST', '/v1/me', data).then((r) => (cache = r));
  },

  /** Exclui a conta (irreversível). confirm = "EXCLUIR". */
  deleteAccount(confirm) {
    return api('DELETE', '/v1/me', { confirm });
  },

  async update(patch) {
    const r = await api('PATCH', '/v1/me', patch);
    cache = { ...cache, profileComplete: true, user: r.user };
    return cache;
  },
};
